// The demo's own storage, in memory: imported first (src/main.tsx), so every module reads it from its first line. The
// demo never sees this browser's own board (its sign-in, its open board, its chat settings) and leaves nothing behind
// for it: a reload starts the demo afresh.
import { DEMO } from "./mode";

class MemoryStorage implements Storage {
  private m = new Map<string, string>();
  get length() {
    return this.m.size;
  }
  clear() {
    this.m.clear();
  }
  getItem(k: string) {
    return this.m.get(String(k)) ?? null;
  }
  key(i: number) {
    return [...this.m.keys()][i] ?? null;
  }
  removeItem(k: string) {
    this.m.delete(String(k));
  }
  setItem(k: string, v: string) {
    this.m.set(String(k), String(v));
  }
}

if (DEMO && typeof window !== "undefined") {
  for (const name of ["localStorage", "sessionStorage"] as const) {
    try {
      Object.defineProperty(window, name, { value: new MemoryStorage(), configurable: true });
    } catch {
      /* a browser that keeps its own: api() still never sends this browser's sign-in from the demo */
    }
  }
  // the chat opens without its History beside it, so the board keeps its room; only ever in the demo's own storage
  if (localStorage instanceof MemoryStorage) localStorage.setItem("cb:chat-list", "closed");
}
